import React, {useEffect, useState} from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, CircularProgress, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Invoice from './Invoice';
import instance from '../../../instance';
import CallNotification from '../../../context/NotificationContext';

interface IInvoicePopupProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    orderId: string | null;
    userId: number | null;
    onClose: () => void;
}

const InvoicePopup = (props: IInvoicePopupProps): React.JSX.Element => {
    const { open, setOpen, orderId, userId, onClose } = props;

    const [invoiceData, setInvoiceData] = useState();
    const [loading, setLoading] = React.useState(true);
    const {handleErrorNotification} = CallNotification();

    useEffect(() => {
        if (!userId || !orderId || !open) return;

        const fetchInvoiceInfo = async () => {
            setLoading(true);
            try {
                const response = await instance.post('/LK', {
                    method: 'GetInvoiceInfo',
                    params: {
                        user_id: userId,
                        order: orderId,
                    },
                });

                handleErrorNotification(response);

                if (response.data?.invoice_info) {
                    setInvoiceData(response.data?.invoice_info);
                }
            } catch (error) {
                console.error('Ошибка при загрузке данных счёта', error);
            } finally {
                setLoading(false);
            }
        };

        void fetchInvoiceInfo();
    }, [userId, orderId, open]);

    const handlerClose = () => {
        setOpen(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handlerClose} fullWidth maxWidth="lg">
            <DialogTitle sx={{ pr: 5 }}>Счёт на оплату</DialogTitle>
            <IconButton onClick={handlerClose} style={{ position: 'absolute', right: 16, top: 16 }}>
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ minHeight: '630px', position: 'relative', padding: 0 }}>
                {loading || !invoiceData ? (
                    <Box height={640} display="flex" alignItems="center" justifyContent="center" gap={2}>
                        <CircularProgress size={24} />
                        <Typography>Формируем счёт…</Typography>
                    </Box>
                    ) : (
                    <Invoice data={invoiceData} viewerHeight={600} />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default InvoicePopup;
